<template>
  <div class="greet-Job">
    <div class="Job-box">
      <div class="header">
        <h1 class="title">选择打招呼的职位</h1>
        <button class="back-btn" @click="handleBack"><i class="el-icon-monitor"
            style="margin-right: 10px;"></i>返回首页</button>
      </div>
      <p class="desc">选择需要智能打招呼的职位，就可以开始打招呼啦，支持多个职位打招呼哦</p>
      <div class="greet-box">
        <div class="greet-left">
          <div class="left-box">
            <button class="nav-btn" :class="{ active: currentTab === 'recommend' }"
              @click="currentTab = 'recommend'">推荐</button>
            <button class="nav-btn new-cattle" :class="{ active: currentTab === 'newCattle' }"
              @click="currentTab = 'newCattle'">新牛人</button>
          </div>
          <div>
            <button class="greet-btn" @click="GreetCall">开始打招呼</button>
            <button class="greet-btn" @click="AgainCall">开始复聊</button>
            <el-dropdown @command="handleSearchCommand" trigger="click">
              <button class="greet-btn">
                开始搜索 <i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="default">默认城市</el-dropdown-item>
                <el-dropdown-item command="national">全国</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <button class="greet-btn" @click="autoReply">自动回复</button>
          </div>
        </div>
        <div class="greet-right">
          <button class="add-btn" @click="addJob">添加新职位</button>
        </div>
      </div>
      <div class="position-list">
        <div class="position-item" v-for="(item, index) in positionList" :key="index"
          :class="clickIndex === index ? 'active' : ''" @click="activeHover(index, item.id)">
          <div class="item-box">
            <label class="cyberpunk-checkbox-label">
              <input type="checkbox" class="cyberpunk-checkbox" v-model="item.isChecked"
                @change="handleCheckboxChange(item)">
            </label>
            <div class="position-info">
              <span class="position-name">{{ item.positionName }} - {{ item.positionCity }}</span>
              <div class="meta-info">
                <span>招呼: {{ item.recruitNum == 0 ? '不限' : item.recruitNum }} </span>
                <span>已打: {{ item.overNum }}</span>
                <span>关键词: {{ item.recruitKey | tokeywordCount }}个</span>
                <span>目标: {{ item.containsCom | tombCount }}个</span>
                <span>过滤: {{ item.filterCom | tofilterCount }}个</span>
              </div>
            </div>
          </div>

          <div class="action-btns">
            <button class="edit-btn" @click="handleEdit(item.id)">编辑</button>
            <button class="delete-btn" @click="handleDelete(item.id, index)">删除</button>
          </div>
        </div>
      </div>
    </div>
    <EditJob v-if="showEdit" :jobID="jobID" :name="name" @MessageClose="MessageClose" @AddClose="AddClose"
      @EditClose="EditClose"></EditJob>
  </div>
</template>

<script>
import EditJob from "@/views/boss/EditJob.vue";
import { getJobList, delectJob, getJobInfo } from "@/request/api";
export default {
  components: { EditJob },
  filters: {
    tokeywordCount(val) {
      if (val !== undefined && val !== '') {
        if (val?.includes(',')) {
          return val.split(',').length;
        }
        return '1';
      }
      return '0';
    },
    tombCount(val) {
      if (val !== undefined && val !== '') {
        if (val?.includes(',')) {
          return val.split(',').length;
        }
        return '1';
      }
      return '0';
    },
    tofilterCount(val) {
      if (val !== undefined && val !== '') {
        if (val?.includes(',')) {
          return val.split(',').length;
        }
        return '1';
      }
      return '0';
    }
  },
  created() {
    if (sessionStorage.getItem("LoginInfo")) {
      this.username = JSON.parse(sessionStorage.getItem("LoginInfo")).username;
      this.getJob();
    }
  },
  data() {
    return {
      currentTab: 'recommend',
      username: '',
      clickIndex: null,
      positionList: [],
      curr: '',
      name: '',
      jobID: '',
      showEdit: false,
      selectedPositions: [],
      newArr: {
        id: '',
        userID: '',
        positionName: '',
        jobName: '',
        recruitNum: '',
        recruitScore: '',
        recruitKey: '',
        minAge: '',
        maxAge: '',
        gender: '',
        exchange: '',
        recentLook: '',
        jobHopping: '',
        eduRequire: '',
        activeCondi: '',
        collegeRequire: [],
        jobIntention: '',
        minSalary: '',
        maxSalary: '',
        containsCom: '',
        filterCom: '',
        greetDesc: '',
        recruitDesc: '',
        greetType: ''
      }
    }
  },
  methods: {
    handleSearchCommand(command) {
      if (command === 'default') {
        this.searchCall(command);
      } else {
        this.searchCall(command);
      }
    },
    autoReply() {
      sessionStorage.setItem('BtnType', '自动回复')
      this.$router.push({
        path: '/bslog'
      })
    },
    async getJob() {
      this.positionList = [];
      const { data: res } = await getJobList({ username: this.username });
      this.positionList = res.data;
    },
    MessageClose() {
      this.showEdit = false;
    },
    AddClose() {
      this.showEdit = false;
      this.positionList = [];
      // this.$message.success('添加成功！');
      this.getJob();
    },
    EditClose() {
      this.showEdit = false;
      this.positionList = [];
      this.$message.success('修改成功！');
      this.getJob();
    },
    activeHover(index, itemId) {
      this.clickIndex = index;
      this.jobID = itemId;
      const currentItem = this.positionList[index];
      currentItem.isChecked = !currentItem.isChecked;
      this.positionList = [...this.positionList];
      this.handleCheckboxChange(currentItem);
    },
    handleCheckboxChange(item) {
      if (item.isChecked) {
        // 如果选中，添加到选中数组（避免重复添加）
        const isAlreadyAdded = this.selectedPositions.some(pos => pos.id === item.id);
        if (!isAlreadyAdded) {
          this.selectedPositions.push(item);
        }
      } else {
        // 如果取消选中，从数组中移除
        this.selectedPositions = this.selectedPositions.filter(pos => pos.id !== item.id);
      }
    },
    handleBack() {
      // 返回首页逻辑，比如路由跳转
      this.$router.push('/assistant');
    },
    addJob() {
      this.showEdit = true;
      this.name = 'Add';
      this.jobID = 0;
    },
    async GreetCall() {
      sessionStorage.removeItem('greetInfoList');
      // 处理选中的多个职位
      const formattedGreetList = [];
      if (this.clickIndex == null) {
        this.$message.warning('请先选择职位');
        return;
      }
      sessionStorage.setItem('BtnType', "打招呼");
      // 遍历所有选中的职位
      for (const position of this.selectedPositions) {
        // 获取当前职位的详细信息
        const { data: res } = await getJobInfo({
          username: this.username,
          jobID: position.id
        });
        var collegeRequire = res.data.collegeRequire;
        if (collegeRequire.indexOf(',') !== -1) {
          collegeRequire = collegeRequire.split(',');
          const replaceMap = {
            "各国名校": "国内外名校",
            "双一流": "双一流院校"
          };
          collegeRequire = collegeRequire.reduce((acc, item) => {
            acc.push(replaceMap[item] || item);
            return acc;
          }, []);
        } else {
          const replaceMap = {
            "各国名校": "国内外名校",
            "双一流": "双一流院校"
          };
          collegeRequire = [replaceMap[collegeRequire] || collegeRequire];
        }
        var eduRequire = res.data.eduRequire;
        if (eduRequire.indexOf(',') !== -1) {
          eduRequire = eduRequire.split(',');
          const replaceMap = {
            "中专": "中专/中技",
          };
          eduRequire = eduRequire.reduce((acc, item) => {
            acc.push(replaceMap[item] || item);
            return acc;
          }, []);
        } else {
          const replaceMap = {
            "中专": "中专/中技",
          };
          eduRequire = [replaceMap[eduRequire] || eduRequire];
        }
        // 转换格式（与原有单个职位处理逻辑一致）
        const formattedItem = {
          id: res.data.id,
          userID: res.data.userID,
          positionName: res.data.positionName,
          positionCity: res.data.positionCity,
          jobName: res.data.jobName,
          wantJobName: res.data.wantJobName,
          recruitNum: res.data.recruitNum === 0 ? '不限' : res.data.recruitNum,
          recruitScore: res.data.recruitScore,
          recruitKey: res.data.recruitKey,
          recruitMajor: res.data.recruitMajor,
          minAge: res.data.minAge,
          maxAge: res.data.maxAge,
          mismatchScore: res.data.mismatchScore,
          keyType: res.data.keyType,
          resumeType: res.data.resumeType,
          gender: res.data.gender === 0 ? '女' : res.data.gender === 1 ? '男' : '不限',
          exchange: res.data.exchange === 0 ? '不限' : '近一个月没有',
          recentLook: res.data.recentLook === 0 ? '不限' : '近14天没有',
          jobHopping: res.data.jobHopping === 0 ? '不限' :
            res.data.jobHopping === 1 ? '5年少于3份' : '平均每份工作大于1年',
          activeCondi: res.data.activeCondi === 0 ? '不限' :
            res.data.activeCondi === 1 ? '刚刚活跃' :
              res.data.activeCondi === 2 ? '今日活跃' :
                res.data.activeCondi === 3 ? '3日内活跃' :
                  res.data.activeCondi === 4 ? '本周活跃' : '本月活跃',
          collegeRequire: collegeRequire,
          eduRequire: eduRequire,
          expRequire: res.data.expRequire,
          jobIntention: res.data.jobIntention === 0 ? '不限' :
            res.data.jobIntention === 1 ? '离职-随时到岗' :
              res.data.jobIntention === 2 ? '在职-暂不考虑' :
                res.data.jobIntention === 3 ? '在职-考虑机会' : '在职-月内到岗',

          firstDegree: res.data.firstDegree,
          greetType: this.currentTab === 'recommend' ? '1' : '2',
          minSalary: res.data.minSalary,
          maxSalary: res.data.maxSalary,
          Chatted: res.data.chatted,
          confirmAddress: res.data.confirmAddress,
          onLineGreet: res.data.onLineGreet,
          containsCom: res.data.containsCom,
          filterCom: res.data.filterCom,
          greetDesc: res.data.greetDesc,
          recruitDesc: res.data.recruitDesc,
          GreetstartTime: res.data.GreetstartTime,
          GreetendTime: res.data.GreetendTime,
        };

        // 添加到新数组
        formattedGreetList.push(formattedItem);
      }

      // 如果没有选中任何职位，使用第一个职位（保持原有逻辑）
      if (formattedGreetList.length === 0) {
        const defaultJobId = this.jobID || this.positionList[0]?.id;
        if (defaultJobId) {
          const { data: res } = await getJobInfo({
            username: this.username,
            jobID: defaultJobId
          });
          // 这里是原有单个职位的转换逻辑，与上面格式一致
          // ...（省略重复代码）
          formattedGreetList.push(formattedItem);
        } else {
          this.$message.warning('请先选择职位');
          return;
        }
      }
      // 存储转换后的数组
      sessionStorage.setItem('greetInfoList', JSON.stringify(formattedGreetList));

      // 可以根据需要跳转到其他页面
      this.$router.push('/bslog');
    },
    async searchCall(command) {
      sessionStorage.removeItem('greetInfoList');
      // 处理选中的多个职位
      const formattedGreetList = [];
      if (this.clickIndex == null) {
        this.$message.warning('请先选择职位');
        return;
      }
      if (command === 'default') {
        sessionStorage.setItem('searchType', '默认城市')
      } else {
        sessionStorage.setItem('searchType', '全国')
      }
      sessionStorage.setItem('BtnType', "搜索");
      // 遍历所有选中的职位
      for (const position of this.selectedPositions) {
        // 获取当前职位的详细信息
        const { data: res } = await getJobInfo({
          username: this.username,
          jobID: position.id
        });
        var collegeRequire = res.data.collegeRequire;
        if (collegeRequire.indexOf(',') != -1) {
          collegeRequire = collegeRequire.split(',');
          const replaceMap = {
            "公办本科": "统招本科",
            "211": "211院校",
            "985": "985院校",
            "留学": "留学生",
            "双一流": "双一流院校"
          };
          collegeRequire = collegeRequire.reduce((acc, item) => {
            acc.push(replaceMap[item] || item);
            return acc;
          }, []);
        } else {
          const replaceMap = {
            "公办本科": "统招本科",
            "211": "211院校",
            "985": "985院校",
            "留学": "留学生",
            "双一流": "双一流院校"
          };
          collegeRequire = [replaceMap[collegeRequire] || collegeRequire];
        }
        // 转换格式（与原有单个职位处理逻辑一致）
        var newEduRequire = res.data.eduRequire?.includes(',')
          ? res.data.eduRequire.split(',')
          : [res.data.eduRequire];

        const formattedItem = {
          id: res.data.id,
          userID: res.data.userID,
          positionName: res.data.positionName,
          positionCity: res.data.positionCity,
          jobName: res.data.jobName,
          wantJobName: res.data.wantJobName,
          recruitNum: res.data.recruitNum === 0 ? '不限' : res.data.recruitNum,
          recruitScore: res.data.recruitScore,
          recruitKey: res.data.recruitKey,
          recruitMajor: res.data.recruitMajor,
          minAge: res.data.minAge,
          maxAge: res.data.maxAge,
          gender: res.data.gender === 0 ? '女' : res.data.gender === 1 ? '男' : '不限',
          exchange: res.data.exchange === 0 ? '不限' : '近30天未和同事交换简历',
          recentLook: res.data.recentLook === 0 ? '不限' : '过滤近14天查看',
          jobHopping: res.data.jobHopping === 0 ? '不限' :
            res.data.jobHopping === 1 ? '5年少于3份' : '时间≥1年',

          eduRequire: newEduRequire[0] === '大专' ? ['不限'] :
            newEduRequire[0] === '本科' ? ['本科及以上'] :
              newEduRequire[0] === '硕士' ? ['硕士及以上'] :
                newEduRequire[0] === '博士' ? ['博士'] : ['不限'],

          activeCondi: res.data.activeCondi === 0 ? '不限' :
            res.data.activeCondi === 1 ? '刚刚活跃' :
              res.data.activeCondi === 2 ? '今日活跃' :
                res.data.activeCondi === 3 ? '3日内活跃' :
                  res.data.activeCondi === 4 ? '近一周活跃' : '近一个月活跃',
          collegeRequire: collegeRequire,
          jobIntention: res.data.jobIntention === 0 ? '不限' :
            res.data.jobIntention === 1 ? '离职-随时到岗' :
              res.data.jobIntention === 2 ? '在职-暂不考虑' :
                res.data.jobIntention === 3 ? '在职-考虑机会' : '在职-月内到岗',
          greetType: this.currentTab === 'recommend' ? '1' : '2',
          keyType: res.data.keyType,
          resumeType: res.data.resumeType,
          confirmAddress: res.data.confirmAddress,
          minSalary: res.data.minSalary,
          maxSalary: res.data.maxSalary,
          Chatted: res.data.chatted,
          onLineGreet: res.data.onLineGreet,
          containsCom: res.data.containsCom,
          filterCom: res.data.filterCom,
          greetDesc: res.data.greetDesc,
          recruitDesc: res.data.recruitDesc
        };
        // 添加到新数组
        formattedGreetList.push(formattedItem);
      }

      // 如果没有选中任何职位，使用第一个职位（保持原有逻辑）
      if (formattedGreetList.length === 0) {
        const defaultJobId = this.jobID || this.positionList[0]?.id;
        if (defaultJobId) {
          const { data: res } = await getJobInfo({
            username: this.username,
            jobID: defaultJobId
          });
          // 这里是原有单个职位的转换逻辑，与上面格式一致
          // ...（省略重复代码）
          formattedGreetList.push(formattedItem);
        } else {
          this.$message.warning('请先选择职位');
          return;
        }
      }
      // 存储转换后的数组
      sessionStorage.setItem('greetInfoList', JSON.stringify(formattedGreetList));

      // 可以根据需要跳转到其他页面
      this.$router.push('/bslog');
    },

    async AgainCall() {
      sessionStorage.removeItem('flList');
      // 处理选中的多个职位
      const formattedGreetList = [];
      if (this.clickIndex == null) {
        this.$message.warning('请先选择职位');
        return;
      }
      sessionStorage.setItem('BtnType', "复聊");
      // 遍历所有选中的职位
      for (const position of this.selectedPositions) {
        const { data: res } = await getJobInfo({
          username: this.username,
          jobID: position.id
        });
        // 转换格式（与原有单个职位处理逻辑一致）
        const formattedItem = {
          jobID: position.id,
          positionName: position.positionName,
          positionCity: position.positionCity,
          flStartTime: res.data.flstartTime,
          flEndTime: res.data.flendTime
        };
        // 添加到新数组
        formattedGreetList.push(formattedItem);
      }
      // 存储转换后的数组
      sessionStorage.setItem('flList', JSON.stringify(formattedGreetList));

      // 可以根据需要跳转到其他页面
      this.$router.push('/bslog');
    },
    handleEdit(id) {
      // 编辑职位逻辑
      this.showEdit = true;
      this.name = 'Edit'
      this.jobID = id;
    },
    async handleDelete(id, index) {
      // 删除职位逻辑，比如提示确认后删除
      if (window.confirm('确定删除该职位吗？')) {
        await delectJob({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, jobID: id });
        this.positionList.splice(index, 1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.greet-Job {
  background-color: #111927;
  color: #fff;
  padding: 0 60px;
  user-select: none;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .Job-box {
    width: 90%;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;

    .title {
      font-size: 36px;
      font-weight: bold;
      background: linear-gradient(90deg, #45A2FF, #d94cb4);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
      text-align: center;
    }

    .back-btn {
      background: linear-gradient(90deg, #6C63FF, #A881FF);
      color: #fff;
      border: none;
      padding: 10px 14px;
      margin-left: 15px;
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    .back-btn:hover {
      background: linear-gradient(90deg, #A881FF, #6C63FF);
    }
  }

  .desc {
    font-size: 16px;
    margin-bottom: 20px;
    color: #ccc;
  }

  .greet-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .greet-left {
      display: flex;
      align-items: center;

      .left-box {

        .nav-btn {
          background-color: #2c3e50;
          color: #fff;
          border: none;
          padding: 6px 12px;
          margin-right: 4px;
          cursor: pointer;
          border-radius: 8px;
        }

        .nav-btn:hover {
          background-color: #5d6f82;
          /* 选中状态的背景色，可自定义 */
        }

        .active {
          font-weight: bold;
          background: linear-gradient(90deg, #45A2FF, #f30dd0);
        }
      }

      .greet-btn {
        background: linear-gradient(90deg, #497efa, #9e5bf6);
        color: #fff;
        border: none;
        padding: 10px 16px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-left: 10px;
      }
    }

    .greet-right {
      .add-btn {
        background: linear-gradient(90deg, #45A2FF, #f30dd0);
        color: #fff;
        border: none;
        padding: 10px 16px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-right: 10px;
      }
    }
  }





  .add-btn:hover {
    background: linear-gradient(30deg, #45A2FF, #f30dd0);
  }

  .greet-btn:hover {
    background: linear-gradient(30deg, #45A2FF, #a557f2);
  }

  .position-list {
    display: flex;
    height: 420px;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
    background-color: #161e2e;
    padding: 10px;
    border-radius: 6px;
    /* 美化滚动条（适用于Chrome、Safari、Edge等WebKit/Blink内核浏览器） */
    scrollbar-width: thin;
    /* Firefox支持的细滚动条 */
    scrollbar-color: rgba(156, 163, 175, 0.5) transparent;
    /* Firefox滚动条颜色 */
    box-shadow: 0px 0px 1px 1px #252d3a;

    .position-item {
      background-color: #303a4a;
      padding: 15px;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .item-box {
        display: flex;
        align-items: center;
      }

      .cyberpunk-checkbox {
        appearance: none;
        width: 20px;
        height: 20px;
        border: 2px solid #45A2FF;
        border-radius: 5px;
        background-color: transparent;
        display: inline-block;
        position: relative;
        margin-right: 10px;
        cursor: pointer;
      }

      .cyberpunk-checkbox:before {
        content: "";
        background-color: #45A2FF;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0);
        width: 10px;
        height: 10px;
        border-radius: 3px;
        transition: all 0.3s ease-in-out;
      }

      .cyberpunk-checkbox:checked:before {
        transform: translate(-50%, -50%) scale(1);
      }

      .cyberpunk-checkbox-label {
        font-size: 18px;
        color: #fff;
        cursor: pointer;
        user-select: none;
        display: flex;
        align-items: center;
      }

      .position-info {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .position-name {
          font-weight: bold;
          font-size: 16px;
        }

        .meta-info {
          display: flex;
          align-items: center;
          gap: 10px;
          color: #aaa;
          font-size: 14px;
        }

      }

      .action-btns {
        display: flex;
        gap: 10px;

        .edit-btn {
          background-color: #6C63FF;
          color: #fff;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
        }

        .edit-btn:hover {
          background-color: #8079fe;
        }

        .delete-btn {
          background-color: #FF4757;
          color: #fff;
          border: none;
          padding: 6px 12px;
          border-radius: 4px;
          cursor: pointer;
        }

        .delete-btn:hover {
          background-color: #fa6d79;
        }
      }
    }

    .active {
      background-color: rgb(84, 80, 103);

      .position-name {
        color: #45A2FF;
      }
    }

    .position-item:hover {
      background-color: rgb(84, 80, 103);

      .position-name {
        color: #45A2FF;
      }
    }
  }

  .position-list::-webkit-scrollbar {
    width: 8px;
    /* 滚动条宽度 */
  }

  .position-list::-webkit-scrollbar-track {
    background: transparent;
    /* 滚动条轨道背景透明 */
  }

  .position-list::-webkit-scrollbar-thumb {
    background-color: rgba(156, 163, 175, 0.5);
    /* 滚动条滑块颜色（灰色半透明） */
    border-radius: 3px;
    /* 滑块圆角 */
  }

  .position-list::-webkit-scrollbar-thumb:hover {
    background-color: rgba(107, 114, 128, 0.7);
    /* 悬停时滑块颜色加深 */
  }
}
</style>